export function difference(surcharge: string, luneEstimate: string): string {
    const surchargNum: number = parseFloat(surcharge)
    const luneEstimateNum: number = parseFloat(luneEstimate)
    return `${Math.round((surchargNum / luneEstimateNum) * 100.0)}`
}
